import React from 'react'

function Schedule(props) {
    return (
        <div className="contentbox">
          <h2>  Your Schedule : {props.selected} </h2>
        </div>
    )
}

export default Schedule
